import Schema from '@/schema/Schema';
import BaseCustomSchema from './BaseCustomSchema';

const CreateTicketQAOptionsLiveChat = fieldListData => {
    let validateObj = {};

    if (fieldListData) {
        validateObj = BaseCustomSchema(fieldListData);
    }

    return Schema.object().shape(validateObj);
};

export default CreateTicketQAOptionsLiveChat;
